export default __webpack_public_path__ + "media/5tashabbusday.c05be94c.mp4";